import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import Component from '@glimmer/component';

interface DictionaryKey {
  key: string;
  label: string;
  placeholder?: string;
  markdown?: boolean;
  media?: boolean;
}

interface Signature {
  Args: {
    item: { dictionary?: string | Record<string, unknown> | null };
    keys: DictionaryKey[];
    isReadOnly: boolean;
  };
}

function getDictionaryValue(
  item: { dictionary?: string | Record<string, unknown> | null },
  key: string
): string {
  try {
    if (typeof item.dictionary === 'object' && item.dictionary !== null) {
      return (item.dictionary[key] as string) || '';
    }
    const dict =
      (JSON.parse(item.dictionary || '{}') as Record<string, string>) || {};
    return dict[key] || '';
  } catch {
    return '';
  }
}

export default class DictionaryEditor extends Component<Signature> {
  updateDictionary = (key: string, event: Event) => {
    const target = event.target as HTMLInputElement | HTMLTextAreaElement;
    const value = target.value;

    try {
      let dict: Record<string, string>;
      if (
        typeof this.args.item.dictionary === 'object' &&
        this.args.item.dictionary !== null
      ) {
        dict = this.args.item.dictionary as Record<string, string>;
      } else {
        dict =
          (JSON.parse((this.args.item.dictionary as string) || '{}') as Record<
            string,
            string
          >) || {};
      }
      dict[key] = value;
      // If it was an object, assign the object back; if string, JSON.stringify
      if (typeof this.args.item.dictionary === 'object') {
        this.args.item.dictionary = dict as Record<string, unknown>;
      } else {
        this.args.item.dictionary = JSON.stringify(dict);
      }
    } catch {
      const dict: Record<string, string> = {};
      dict[key] = value;
      if (typeof this.args.item.dictionary === 'object') {
        this.args.item.dictionary = dict as Record<string, unknown>;
      } else {
        this.args.item.dictionary = JSON.stringify(dict);
      }
    }
  };

  <template>
    <div>
      {{#each @keys as |field|}}
        <div class="row mb-3">
          <label for="dict-{{field.key}}" class="col-sm-3 col-form-label">
            {{field.label}}
          </label>
          <div class="col-sm-9">
            {{#if field.markdown}}
              <textarea
                id="dict-{{field.key}}"
                class="form-control font-monospace"
                rows="4"
                placeholder={{field.placeholder}}
                disabled={{@isReadOnly}}
                {{on "input" (fn this.updateDictionary field.key)}}
              >{{getDictionaryValue @item field.key}}</textarea>
              <div class="form-text">Supports Markdown formatting</div>
            {{else if field.media}}
              <input
                id="dict-{{field.key}}"
                type="url"
                class="form-control font-monospace"
                placeholder={{field.placeholder}}
                value={{getDictionaryValue @item field.key}}
                disabled={{@isReadOnly}}
                {{on "input" (fn this.updateDictionary field.key)}}
              />
              <div class="form-text">Media URL (image/video)</div>
            {{else}}
              <input
                id="dict-{{field.key}}"
                type="text"
                class="form-control"
                placeholder={{field.placeholder}}
                value={{getDictionaryValue @item field.key}}
                disabled={{@isReadOnly}}
                {{on "input" (fn this.updateDictionary field.key)}}
              />
            {{/if}}
          </div>
        </div>
      {{/each}}
    </div>
  </template>
}
